"use client";

import type { User } from "@/modules/session/types";
import { datadogRum } from "@datadog/browser-rum";

/**
 * Set Datadog tracking consent based on user action (e.g., accepting cookies).
 */
export function setDatadogTrackingConsent(consent: "granted" | "not-granted") {
  datadogRum.setTrackingConsent(consent);
}

/**
 * Update Datadog user information dynamically.
 */
export function setDatadogUser(user: Partial<User>) {
  datadogRum.setUser(user);
}

/**
 * Send custom action
 * https://docs.datadoghq.com/real_user_monitoring/guide/send-rum-custom-actions/?tab=npm#instrument-your-code
 */
export function sendDatadogAction(name: string, context?: object) {
  datadogRum.addAction(name, context);
}

/**
 * Set a custom context to the current view.
 * https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/?tab=npm#view-context
 */
export function setDatadogViewProperty(name: string, value: string | object) {
  datadogRum.setViewContextProperty(name, value);
}

/**
 * Update Datadog user information dynamically.
 */
export function clearDatadogUser() {
  datadogRum.clearUser();
}
